import { render, staticRenderFns } from "./MarketplaceNavButton.vue?vue&type=template&id=42dc4e22&scoped=true"
import script from "./MarketplaceNavButton.vue?vue&type=script&lang=js"
export * from "./MarketplaceNavButton.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceNavButton.vue?vue&type=style&index=0&id=42dc4e22&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc4e22",
  null
  
)

export default component.exports